module.exports = __webpack_public_path__ + "img/jinbi02@2x.803eb373.png";